export default __webpack_public_path__ + "static/media/hero-fashion-new.f389c030.jpg";